export default [
    {
      title: 'Data Management',
      customIcon: 'DataManageSVG',
      children: [
        {
          title: 'Customer',
          route: 'data-management-list',
          path: '/data-management/list/Customer_List',
        },
      ],
    },
  ];